import React from 'react';
import { Navigate } from 'react-router-dom';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PermissionGuard, PermissionsFn } from '~/core/PermissionGuard';
import { ExploDashboardContainer } from '~/packages/explo/ui/ExploDashboardContainer';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  return (
    <ExploDashboardContainer
      organizationId={user.organization.id}
      exploPlacement="lenderPortfolioTab"
    />
  );
};

// Exports
export const permissions: PermissionsFn = (context) => {
  return context.flags.productsAnalyticsStratsPermissions;
};
export const Route = () => {
  return (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/" replace />}
    >
      <RouteErrorBoundary
        fallback={({ message, showErrorToast }) => {
          showErrorToast(message);
          return <Navigate to="/" />;
        }}
      >
        <RouteBase />
      </RouteErrorBoundary>
    </PermissionGuard>
  );
};
